import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getCampaigns = async (appId: string) => {
  const { data } = await IBModuleApi.get(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/marketingcampaigns?appId=${appId}`
  );

  return data;
};

export const createCampaign = async (createInfo: any, appId: string) => {
  const { data } = await IBModuleApi.post(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/marketingcampaigns?appId=${appId}`,
    createInfo
  );

  return data;
};

export const updateCampaign = async (updateInfo: any, appId: string) => {
  const { data } = await IBModuleApi.put(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/marketingcampaigns?appId=${appId}`,
    updateInfo
  );

  return data;
};

export const deleteCampaign = async (campaignId: number) => {
  const { data } = await IBModuleApi.delete(
    `${IBModuleApi.defaults.baseURL}/${urlContexts.console}/rest/1.0/cs/marketingcampaigns/${campaignId}`
  );

  return data;
};
